import { LOGO } from '../constants';

/** Brand lockup: the CR7 Museu logo, linking back to the top of the page. */
export const Brand = () => (
  <a className="brand" href="#top" aria-label="CR7 Museu">
    <img src={LOGO} alt="CR7 Museu" />
  </a>
);
